/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import TextPlaceholder from 'Component/TextPlaceholder';
import { isB2BUser } from 'Util/Helper';

/** @namespace Pwa/Component/CategoryItemsCount/Component/CategoryItemsCountComponent */
export class CategoryItemsCountComponent extends PureComponent {
    static propTypes = {
        totalItems: PropTypes.number.isRequired,
        isMatchingListFilter: PropTypes.bool
    };

    static defaultProps = {
        isMatchingListFilter: false
    };

    render() {
        const {
            totalItems,
            isMatchingListFilter,
            pages,
            customer: { is_b2b } = {}
        } = this.props;

        // const b2cProducts = (pages[1] || []).filter((item) => {
        //     const attr = item.attributes?.b2c_product;
        //     return attr?.attribute_code === 'b2c_product' && attr?.attribute_value === '1';
        // });

        const b2cProducts = (pages[1] || []).filter((item) => {
            const attr = item.attributes?.b2c_product;

            // If attribute is missing, treat as B2C
            if (!attr) {
                return true;
            }

            // If attribute exists, check its value
            return attr?.attribute_code === 'b2c_product' && attr?.attribute_value === '1';
        });

        let totalItemsCount = totalItems;
        if (isB2BUser(is_b2b)) {
            totalItemsCount = totalItems - b2cProducts.length;
        }

        return (
            <p block="CategoryPage" elem="ItemsCount">
                <TextPlaceholder
                  content={ (!isMatchingListFilter
                      ? __('Products are loading...')
                      : __('%s items found', totalItemsCount)
                  ) }
                />
            </p>
        );
    }
}

export default CategoryItemsCountComponent;
